import React from "react";
import { getIdWithToken } from "../../../../utils/storage/Token";
import { useFetchPendingAlerts } from "../../../../service/Business/DeclarationService";
import "./DeclarationAlerts.scss";

type DeclarationAlertsProps = {
    onNavigate: (menu: string) => void;
};

const MONTH_NAMES_FR = [
    "janvier",
    "février",
    "mars",
    "avril",
    "mai",
    "juin",
    "juillet",
    "août",
    "septembre",
    "octobre",
    "novembre",
    "décembre",
];

/**
 * Bandeaux d'alerte affichés sur le dashboard pour rappeler à l'utilisateur
 * les déclarations TVA et URSSAF en attente du mois courant.
 */
const DeclarationAlerts: React.FunctionComponent<DeclarationAlertsProps> = ({ onNavigate }) => {
    const { data } = useFetchPendingAlerts(getIdWithToken());

    if (!data || (!data.tva && !data.urssaf)) return null;

    const formatEcheance = (iso: string): string => {
        const d = new Date(iso);
        return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" });
    };

    return (
        <div className="declarationAlerts">
            {data.tva && (
                <div className="declarationAlert declarationAlertTva" role="alert">
                    <div className="declarationAlertIcon">
                        <span className="material-symbols-outlined">receipt_long</span>
                    </div>
                    <div className="declarationAlertContent">
                        <div className="declarationAlertBadge">
                            <span className="material-symbols-outlined">priority_high</span>
                            Important
                        </div>
                        <div className="declarationAlertTitle">Déclaration TVA en attente</div>
                        <div className="declarationAlertDesc">
                            Votre déclaration de TVA pour {MONTH_NAMES_FR[data.tva.month]} {data.tva.year} doit être
                            effectuée sur le site des{" "}
                            <a target="_blank" rel="noopener noreferrer" href="https://cfspro-idp.impots.gouv.fr/">
                                impôts
                            </a>{" "}
                            ou{" "}
                            <a target="_blank" rel="noopener noreferrer" href="https://portailpro.gouv.fr/ms/login">
                                mon portail pro
                            </a>
                            .
                        </div>
                    </div>
                    <button className="declarationAlertBtn" onClick={() => onNavigate("resume_dec")} type="button">
                        Déclarer
                        <span className="material-symbols-outlined">arrow_forward</span>
                    </button>
                </div>
            )}

            {data.urssaf && (
                <div className="declarationAlert declarationAlertUrssaf" role="alert">
                    <div className="declarationAlertIcon">
                        <span className="material-symbols-outlined">account_balance</span>
                    </div>
                    <div className="declarationAlertContent">
                        <div className="declarationAlertBadge">
                            <span className="material-symbols-outlined">warning</span>
                            Action urgente
                        </div>
                        <div className="declarationAlertTitle">Déclaration URSSAF en attente</div>
                        <div className="declarationAlertDesc">
                            {data.urssaf.desc} {data.urssaf.year} — exigible le{" "}
                            {formatEcheance(data.urssaf.dateEcheance)}.
                        </div>
                    </div>
                    <button className="declarationAlertBtn" onClick={() => onNavigate("resume_dec")} type="button">
                        Déclarer
                        <span className="material-symbols-outlined">arrow_forward</span>
                    </button>
                </div>
            )}
        </div>
    );
};

export default DeclarationAlerts;
